// Module
var code = "<span>{{ $ctrl.getFormattedIban($ctrl.iban) }}</span> ";
// Exports
module.exports = code;